export const SUPPORTED_LOCALES = ['en', 'ka'] as const;

export type TLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: TLocale = 'en';

export const ALLOWED_LOCALES = new Set<string>(SUPPORTED_LOCALES);
